<template>
  <el-dialog
    :title="'Program lucru ' + this.selectedObject.Nume"
    id="popup_dialog"
    :visible.sync="showPopup"
    class="my-dialog-class"
  >

    <el-tooltip placement="bottom-end"  effect="light">
      <div slot="content">Nu se pot face programari decat in timpul programului, excluzand pauza.<br/></div>
      <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
    </el-tooltip>
    <el-form
      label-position="top"
      :inline="false"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
      v-loading="loadingVisible"
    >
       <el-row :gutter="15"
         v-for="(product, i) in selectedObject.ProgramSapt"
         :key="'ziua' + i"
        >

        <el-col class="input-element">
          <el-form-item :label="'Program '+ selectedObject.ProgramSapt[i].zi" :prop="'Program '+ selectedObject.ProgramSapt[i].zi">
            <el-time-picker
              size="small"
              v-model="selectedObject.ProgramSapt[i].program"
              is-range
              value-format = "HH:mm:00"
              format = "HH:mm"
              clearable
              range-separator="-"
              start-placeholder="Inceput program"
              end-placeholder="Sfarsit program"
            />
          </el-form-item>
        </el-col>       
        
        <el-col class="input-element">
          <el-form-item :label="'Pauza '+ selectedObject.ProgramSapt[i].zi" :prop="'Pauza '+ selectedObject.ProgramSapt[i].zi">
            <el-time-picker
              size="small"
              v-model="selectedObject.ProgramSapt[i].pauza"
              is-range
              value-format = "HH:mm:00"
              format = "HH:mm"
              clearable
              range-separator="-"
              start-placeholder="Inceput pauza"
              end-placeholder="Sfarsit pauza"
            />
          </el-form-item>
        </el-col>    
        
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="pune_default_firma()"> Pune program default </el-button>
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import NewPassword from "@/pages/Admin/NewPassword.vue";

export default {
  name: "Utilizatori_dialog",
  extends: BasePage,
  components: {
    NewPassword,
  },
  data() {
    return {
      showPopup: false,
      selectedObject: {
        ProgramSapt: [
          { zi: "Duminica", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Luni", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Marti", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Miercuri", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Joi", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Vineri", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
          { zi: "Sambata", program: ["00:00:00-00:00:00"], pauza: ["00:00:00-00:00:00"],  },
        ],
        Nume: "",
        Email: "",
        Parola: "",
        IdGrupDrepturi: "",
        CentreProductie: "",
        InceputPauza: "",
        SfarsitPauza: "",
      },
      Info: {
        rights_groups: [],
      },
    
    };
  },

  methods: {


    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    show_me: async function (id) {
    
      if (id == null) {
        this.mode = "add";
        this.selectedObject.Nume = "";
        this.selectedObject.Email = "";
        this.selectedObject.Parola = "";
        this.selectedObject.CentreProductie = [];
      } else {
        this.mode = "edit";
        var result = await this.post("utilizatori/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
        
      }
      if(!this.selectedObject.ProgramSapt){

        // let progLV = [ this.setari.OraStartLV , this.setari.OraStopLV];

        this.selectedObject.ProgramSapt = [
          { zi: "Duminica", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Luni", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Marti", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Miercuri", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Joi", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Vineri", program: [ "", "" ], pauza: [ "" ],  },
          { zi: "Sambata", program: [ "", "" ], pauza: [ "" ],  },
        ];
        }

      this.showPopup = true;
    },
    async get_info() {
      var response = await this.post("utilizatori/get_info_for_dialog");
      this.setari = response.setari;
    },   
    
    pune_default_firma() {
     
      if(this.setari.SeLucreazaD == "1") this.selectedObject.ProgramSapt[0].program = [ this.setari.OraStartD , this.setari.OraStopD];
      else this.selectedObject.ProgramSapt[0].program =  [ "", "" ];

      if(this.setari.SeLucreazaS == "1") this.selectedObject.ProgramSapt[6].program = [ this.setari.OraStartS , this.setari.OraStopS];
      else this.selectedObject.ProgramSapt[6].program =  [ "", "" ];

      this.selectedObject.ProgramSapt[1].program = [ this.setari.OraStartLV , this.setari.OraStopLV];
      this.selectedObject.ProgramSapt[2].program = [ this.setari.OraStartLV , this.setari.OraStopLV];
      this.selectedObject.ProgramSapt[3].program = [ this.setari.OraStartLV , this.setari.OraStopLV];
      this.selectedObject.ProgramSapt[4].program = [ this.setari.OraStartLV , this.setari.OraStopLV];
      this.selectedObject.ProgramSapt[5].program = [ this.setari.OraStartLV , this.setari.OraStopLV];

    },
    save: async function () {
      this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("utilizatori/save_program_sapt", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject= {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  width: 100%;
}
</style>